// import React, { useState, useEffect } from 'react';
// import { useParams, useNavigate } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';
// import { fetchPoliciesDataRequest } from '../../../redux/api/apiSlice';
// import { 
//   ArrowBack, 
//   LocationOn, 
//   FilterList,
//   ExpandMore,
//   ExpandLess,
//   CheckBox,
//   CheckBoxOutlineBlank,
//   WbSunny,
//   Terrain,
//   Public,
//   LocalFireDepartment,
//   Opacity,
//   Cloud,
//   LocationCity
// } from '@mui/icons-material';
// import styles from './PolicyDetailPage.module.css';
// import { useTranslation } from "react-i18next";


// const HAZARDS = [
//   { name: 'Heatwaves', icon: <WbSunny className={styles.hazardIcon} /> },
//   { name: 'Landslides', icon: <Terrain className={styles.hazardIcon} /> },
//   { name: 'Earthquakes', icon: <Public className={styles.hazardIcon} /> },
//   { name: 'Fires', icon: <LocalFireDepartment className={styles.hazardIcon} /> },
//   { name: 'Floods', icon: <Opacity className={styles.hazardIcon} /> },
//   { name: 'Rainstorms', icon: <Cloud className={styles.hazardIcon} /> },
//   { name: 'Urban Fires', icon: <LocationCity className={styles.hazardIcon} /> },
// ];

// const PolicyDetailPage = () => {
//   const { slug, section } = useParams();
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const { policiesData, loading, error } = useSelector((state) => state.api);
//   const [activeSection, setActiveSection] = useState('plan');
//   const [selectedHazards, setSelectedHazards] = useState(new Set());
//   const [expandedLabs, setExpandedLabs] = useState({});
//   const [expandedGaps, setExpandedGaps] = useState({});
//   const [filterOpen, setFilterOpen] = useState(false);
//   const { i18n } = useTranslation();
//   const lang = i18n.language || "en";


//   useEffect(() => {
//     if (!slug) return;

//     dispatch(
//       fetchPoliciesDataRequest({
//         lang,
//         slug
//         })
//       );
//     }, [dispatch, lang, slug]);


//   const toggleHazard = (hazard) => {
//     setSelectedHazards(prev => {
//       const newSet = new Set(prev);
//       if (newSet.has(hazard)) {
//         newSet.delete(hazard);
//       } else {
//         newSet.add(hazard);
//       }
//       return newSet;
//     });
//   };

//   const toggleLabExpansion = (labIndex) => {
//     setExpandedLabs(prev => ({
//       ...prev,
//       [labIndex]: !prev[labIndex]
//     }));
//   };

//   const toggleGapsExpansion = (labIndex) => {
//     setExpandedGaps(prev => ({
//       ...prev,
//       [labIndex]: !prev[labIndex]
//     }));
//   };

//   const clearFilters = () => {
//     setSelectedHazards(new Set());
//   };

//   const allSelected = selectedHazards.size === HAZARDS.length;
//   const toggleSelectAll = () => {
//     setSelectedHazards(allSelected ? new Set() : new Set(HAZARDS.map(h => h.name)));
//   };

//   const policy = policiesData?.data?.subcategory?.[0];

//   // Get all section titles
//   const sectionTitles = policy?.sections?.map(s => s.title.toLowerCase().replace(/\s+/g, '-')) || [];

//   // Set active section based on URL param or default to first section
//   useEffect(() => {
//     if (policy?.sections?.length) {
//       if (section && sectionTitles.includes(section)) {
//         setActiveSection(sectionTitles.indexOf(section) === 0 ? 'plan' : 'analysis');
//       } else {
//         setActiveSection('plan');
//       }
//     }
//   }, [policy, section]);

//   // When a tab is clicked, update the URL and active section
//   const handleTabClick = (title, idx) => {
//     const slug = title.toLowerCase().replace(/\s+/g, '-');
//     setActiveSection(idx === 0 ? 'plan' : 'analysis');
//     navigate(`/solutions/policies/${slug}/${section.key}`);
//   };

//   const sections = policy?.sections?.reduce((acc, section) => {
//     if (section.title === "Crisis Management and Preparedness Plan") {
//       acc.plan = section;
//     } else if (section.title === "Analysis Results") {
//       acc.analysis = section;
//     }
//     return acc;
//   }, {}) || {};

//   const filterContentByHazard = (content) => {
//     if (selectedHazards.size === 0) return content;
//     return content.map(lab => {
//       // Check if lab has a hazards array
//       if (Array.isArray(lab.hazards) && lab.hazards.length > 0) {
//         const matchesAnyHazard = Array.from(selectedHazards).some(hazard => 
//           lab.hazards.includes(hazard)
//         );
//         return matchesAnyHazard ? lab : null;
//       }
//       return null;
//     }).filter(Boolean);
//   };

//   // Prepare filtered sections for tab logic
//   const filteredSections = [
//     { key: 'plan', title: 'Crisis Management Plan', content: sections.plan?.content, rawSection: sections.plan },
//     { key: 'analysis', title: 'Analysis Results', content: sections.analysis?.content, rawSection: sections.analysis }
//   ];

//   // Helper to check if filtered content is empty
//   function isContentEmpty(content) {
//     if (!content) return true;
//     if (typeof content === 'string') return content.trim() === '';
//     if (Array.isArray(content)) return content.length === 0;
//     if (typeof content === 'object') return Object.keys(content).length === 0;
//     return true;
//   }

//   // Only show tabs with non-empty filtered content if a hazard is selected
//   const visibleSections = filteredSections.filter(section => {
//     if (selectedHazards.size === 0) return true;
//     let filteredContent = section.content;
//     if (section.key === 'analysis' && Array.isArray(section.content)) {
//       filteredContent = filterContentByHazard(section.content);
//       return !isContentEmpty(filteredContent);
//     }
//     if (section.key === 'plan' && typeof section.content === 'object' && section.content !== null) {
//       // For plan, check if hazards array contains any selected hazard
//       if (Array.isArray(section.content.hazards) && section.content.hazards.length > 0) {
//         return Array.from(selectedHazards).some(hazard =>
//           section.content.hazards.includes(hazard)
//         );
//       }
//       return false;
//     }
//     return !isContentEmpty(filteredContent);
//   });

//   React.useEffect(() => {
//     if (visibleSections.length > 0 && !visibleSections.some(s => s.key === activeSection)) {
//       setActiveSection(visibleSections[0].key);
//     }
//   }, [selectedHazards, activeSection, visibleSections]);

//   // Early returns after all hooks
//   if (loading) {
//     return <div className={styles.mainContainer}>Loading...</div>;
//   }

//   if (error) {
//     return <div className={styles.mainContainer}>Error: {error}</div>;
//   }

//   if (!policiesData?.data?.subcategory) {
//     return <div className={styles.mainContainer}>No policy data available</div>;
//   }

//   if (!policy) {
//     return <div className={styles.mainContainer}>Policy not found</div>;
//   }

//   const renderContent = (content) => {
//     if (typeof content === 'string') {
//       return (
//         <div dangerouslySetInnerHTML={{ 
//           __html: content
//             .replace(/•/g, '</li><li>')
//             .replace(/([^>])\n/g, '$1</p><p>')
//             .replace(/^/, '<p>')
//             .replace(/$/, '</p>')
//             .replace(/<li>/, '<ul><li>')
//             .replace(/li>([^<])/g, 'li></ul>$1') 
//         }} />
//       );
//     }

//     if (Array.isArray(content)) {
//       return (
//         <div className={styles.analysisSection}>
//           {filterContentByHazard(content).map((lab, idx) => (
//             <div key={idx} className={styles.labCard}>
//               <div 
//                 className={styles.labHeader}
//                 onClick={() => toggleLabExpansion(idx)}
//               >
//                 <div className={styles.labHeaderContent}>
//                   <LocationOn className={styles.locationIcon} />
//                   <h3 className={styles.labTitle}>{lab.lab}</h3>
//                 </div>
//                 {expandedLabs[idx] ? (
//                   <ExpandLess className={styles.expandIcon} />
//                 ) : (
//                   <ExpandMore className={styles.expandIcon} />
//                 )}
//               </div>

//               {expandedLabs[idx] && (
//                 <>
//                   <p className={styles.labText}>{lab.text}</p>
//                   {lab.gaps && (
//                     <div className={styles.gapsSection}>
//                       <div 
//                         className={styles.gapsHeader}
//                         onClick={() => toggleGapsExpansion(idx)}
//                       >
//                         <h4 className={styles.gapsTitle}>Identified Gaps</h4>
//                         {expandedGaps[idx] ? (
//                           <ExpandLess className={styles.expandIcon} />
//                         ) : (
//                           <ExpandMore className={styles.expandIcon} />
//                         )}
//                       </div>

//                       {expandedGaps[idx] && (
//                         <div className={styles.gapsGrid}>
//                           {lab.gaps.map((gap, gapIdx) => (
//                             <div key={gapIdx} className={styles.gapCard}>
//                               <div className={styles.gapContent}>
//                                 <h5 className={styles.gapArea}>{gap.area}</h5>
//                                 <p className={styles.gapDescription}>{gap.description}</p>
//                               </div>
//                             </div>
//                           ))}
//                         </div>
//                       )}
//                     </div>
//                   )}
//                 </>
//               )}
//             </div>
//           ))}
//         </div>
//       );
//     }

//     return null;
//   };

//   return (
//     <div className={styles.mainContainer}>
//       <button className={styles.backButton} onClick={() => navigate('/solutions/policies')}>
//         <ArrowBack />
//         Back to Policies
//       </button>

//       <div className={styles.headerPaper}>
//         <h1 className={styles.mainTitle}>{policy.name}</h1>
//         <p className={styles.summary}>{policy.description}</p>
//       </div>

//       {/* Collapsible Hazard Filter Card - always above tabs */}
//       <div className={styles.collapsibleCard}>
//         <div className={styles.collapsibleHeader} onClick={() => setFilterOpen(o => !o)}>
//           <div className={styles.collapsibleTitle}>
//             <FilterList className={styles.collapsibleIcon} />
//             Filter by Hazards
//           </div>
//           {filterOpen ? (
//             <ExpandLess className={`${styles.collapseArrow} open`} />
//           ) : (
//             <ExpandMore className={styles.collapseArrow} />
//           )}
//         </div>
//         {filterOpen && (
//           <div className={styles.filterContent}>
//             <div className={styles.hazardList}>
//               <div className={styles.selectAllRow}>
//                 <input
//                   type="checkbox"
//                   className={styles.hazardCheckbox}
//                   checked={allSelected}
//                   onChange={toggleSelectAll}
//                   id="selectAllHazards"
//                 />
//                 <label htmlFor="selectAllHazards" className={styles.hazardLabel}>
//                   Select All Hazards
//                 </label>
//               </div>
//               {HAZARDS.map(hazard => (
//                 <div className={styles.hazardRow} key={hazard.name}>
//                   <input
//                     type="checkbox"
//                     className={styles.hazardCheckbox}
//                     checked={selectedHazards.has(hazard.name)}
//                     onChange={() => toggleHazard(hazard.name)}
//                     id={`hazard-${hazard.name}`}
//                   />
//                   {hazard.icon}
//                   <label htmlFor={`hazard-${hazard.name}`} className={styles.hazardLabel}>
//                     {hazard.name}
//                   </label>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}
//       </div>

//       <div className={styles.navigationContainer}>
//         {visibleSections.map((section, idx) => (
//           <button
//             key={section.key}
//             className={`${styles.navButton} ${activeSection === (idx === 0 ? 'plan' : 'analysis') ? styles.active : ''}`}
//             onClick={() => handleTabClick(section.key)}
//           >
//             {section.title}
//           </button>
//         ))}
//       </div>

//       <div className={styles.contentSection}>
//         {visibleSections.map(section => (
//           activeSection === section.key && section.key === 'plan' && section.rawSection && (
//             <div key={section.key} className={styles.card}>
//               <h2 className={styles.mainSectionTitle}>Crisis Management and Preparedness Plan</h2>
//               <div className={styles.cardContent}>
//                 {section.rawSection.content.text && renderContent(section.rawSection.content.text)}
//                 {section.rawSection.content.objectives && (
//                   <div className={styles.objectivesContainer}>
//                     <h3 className={styles.subTitle}>Key Objectives</h3>
//                     <div className={styles.objectivesGrid}>
//                       {section.rawSection.content.objectives.map((obj, idx) => (
//                         <div key={idx} className={styles.objectiveCard}>
//                           <h4 className={styles.objectiveTitle}>{obj.title}</h4>
//                           <p className={styles.objectiveDescription}>{obj.description}</p>
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>
//           )
//         ))}
//         {visibleSections.map(section => (
//           activeSection === section.key && section.key === 'analysis' && section.rawSection && (
//             <div key={section.key} className={styles.card}>
//               <h2 className={styles.mainSectionTitle}>Analysis Results</h2>
//               <div className={styles.cardContent}>
//                 {renderContent(section.rawSection.content)}
//               </div>
//             </div>
//           )
//         ))}
//       </div>
//     </div>
//   );
// };

// export default PolicyDetailPage; 


import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchPoliciesDataRequest } from '../../../redux/api/apiSlice';
import {
  ArrowBack,
  CheckCircle,
  LocationOn,
  ExpandMore,
  ExpandLess,
  FilterList,
  WbSunny,
  Terrain,
  Public,
  LocalFireDepartment,
  Opacity,
  Cloud,
  LocationCity
} from '@mui/icons-material';
import styles from './PolicyDetailPage.module.css';
import { useTranslation } from "react-i18next";
import { Typography } from '@mui/material';

/* ----------------------------------
   HAZARDS (IDENTIEK AAN PAST EXPERIENCES)
---------------------------------- */
const HAZARDS = [
  { name: 'Heatwaves', icon: <WbSunny className={styles.hazardIcon} /> },
  { name: 'Landslides', icon: <Terrain className={styles.hazardIcon} /> },
  { name: 'Earthquakes', icon: <Public className={styles.hazardIcon} /> },
  { name: 'Fires', icon: <LocalFireDepartment className={styles.hazardIcon} /> },
  { name: 'Floods', icon: <Opacity className={styles.hazardIcon} /> },
  { name: 'Rainstorms', icon: <Cloud className={styles.hazardIcon} /> },
  { name: 'Urban Fires', icon: <LocationCity className={styles.hazardIcon} /> },
];

const PolicyDetailPage = () => {
  const { slug, section } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { policiesData, loading, error } = useSelector((state) => state.api);

  const { t, i18n } = useTranslation();
  const lang = i18n.language || "en";

  const [activeSection, setActiveSection] = useState(null);
  const [expandedLabs, setExpandedLabs] = useState({});
  const [expandedGaps, setExpandedGaps] = useState({});
  const [selectedHazards, setSelectedHazards] = useState([]);
  const [filterOpen, setFilterOpen] = useState(false);

  const [expandedObjectives, setExpandedObjectives] = useState({});

  const toggleObjectiveExpansion = (idx) => {
    setExpandedObjectives(prev => ({
      ...prev,
      [idx]: !prev[idx]
    }));
  };

  /* ----------------------------------
     FETCH DATA
  ---------------------------------- */
  useEffect(() => {
    if (!slug) return;

    dispatch(
      fetchPoliciesDataRequest({
        lang,
        slug
      })
    );
  }, [dispatch, lang, slug]);

  const policy = policiesData?.data?.subcategory?.[0];

  /* ----------------------------------
     SYNC ACTIVE TAB WITH URL
  ---------------------------------- */
  useEffect(() => {
    if (!policy?.sections?.length) return;

    const sectionKeys = policy.sections.map(s => s.key);

    if (section && sectionKeys.includes(section)) {
      setActiveSection(section);
    } else {
      setActiveSection(sectionKeys[0]);
    }
  }, [policy, section]);

  /* ----------------------------------
     EARLY RETURNS
  ---------------------------------- */
  if (loading) return <div className={styles.mainContainer}>Loading...</div>;
  if (error) return <div className={styles.mainContainer}>Error: {error}</div>;
  if (!policy) return <div className={styles.mainContainer}>Policy not found</div>;

  /* ----------------------------------
     NORMALIZE SECTIONS
  ---------------------------------- */
  const sections = policy.sections.reduce((acc, s) => {
    acc[s.key] = s;
    return acc;
  }, {});

  const currentSection = activeSection ? sections[activeSection] : null;

  /* ----------------------------------
     HAZARD FILTER LOGIC (POLICIES)
  ---------------------------------- */
  const toggleHazard = (hazard) => {
    setSelectedHazards(prev =>
      prev.includes(hazard)
        ? prev.filter(h => h !== hazard)
        : [...prev, hazard]
    );
  };

  const allSelected = selectedHazards.length === HAZARDS.length;

  const toggleSelectAll = () => {
    setSelectedHazards(allSelected ? [] : HAZARDS.map(h => h.name));
  };

  const filterByHazards = (labs) => {
    if (!selectedHazards.length) return labs;
    return labs.filter(lab =>
      Array.isArray(lab.hazards) &&
      lab.hazards.some(h => selectedHazards.includes(h))
    );
  };

  /* ----------------------------------
     HANDLERS
  ---------------------------------- */
  const handleTabClick = (key) => {
    setActiveSection(key);
    setSelectedHazards([]); // reset filter on tab switch
    navigate(`/solutions/policies/${slug}/${key}`);
  };

  const toggleLabExpansion = (idx) => {
    setExpandedLabs(prev => ({ ...prev, [idx]: !prev[idx] }));
  };

  const toggleGapsExpansion = (idx) => {
    setExpandedGaps(prev => ({ ...prev, [idx]: !prev[idx] }));
  };

  /* ----------------------------------
     RENDER ANALYSIS RESULTS (MET FILTER)
  ---------------------------------- */
  const renderAnalysisResults = (labs) => {
    const filteredLabs = filterByHazards(labs);

    if (!filteredLabs.length) {
      return (
        <div className={styles.noLabsMsg}>
          No labs match the selected hazards.
        </div>
      );
    }

    return filteredLabs.map((lab, idx) => (
      <div key={idx} className={styles.labCard}>
        <div
          className={styles.labHeader}
          onClick={() => toggleLabExpansion(idx)}
        >
          <div className={styles.labHeaderContent}>
            <LocationOn className={styles.locationIcon} />
            <Typography variant="h6" className={styles.labTitle}>
              {lab.lab}
            </Typography>
          </div>
          {expandedLabs[idx] ? <ExpandLess /> : <ExpandMore />}
        </div>

        {expandedLabs[idx] && (
          <>
            {lab.text && (
              <Typography variant="body1" className={styles.labText}>
                {lab.text}
              </Typography>
            )}

            {lab.gaps?.length > 0 && (
              <div className={styles.gapsSection}>
                <div
                  className={styles.gapsHeader}
                  onClick={() => toggleGapsExpansion(idx)}
                >
                  <Typography variant="h6">
                    Identified Gaps
                  </Typography>
                  {expandedGaps[idx] ? <ExpandLess /> : <ExpandMore />}
                </div>

                {expandedGaps[idx] && (
                  <div className={styles.gapsGrid}>
                    {lab.gaps.map((gap, gapIdx) => (
                      <div key={gapIdx} className={styles.gapCard}>
                        <Typography
                          variant="h6"
                          component="h5"
                          className={styles.gapArea}
                        >
                          {gap.area}
                        </Typography>

                        <Typography
                          variant="body1"
                          component="p"
                          className={styles.gapDescription}
                        >
                          {gap.description}
                        </Typography>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </>
        )}
      </div>
    ));
  };

  /* ----------------------------------
     RENDER
  ---------------------------------- */
  return (
    <div className={styles.mainContainer}>
      <button
        className={styles.backButton}
        onClick={() => navigate('/solutions/policies')}
      >
        <ArrowBack />
        {t("solutions.navigation.backToPages.policies")}
      </button>

      <div className={styles.headerPaper}>
        <Typography variant="h6" className={styles.mainTitle}>
          {policy.name}
        </Typography>

        <Typography variant="body1" className={styles.summary}>
          {policy.description}
        </Typography>
      </div>

      {/* HAZARD FILTER – ONLY AT ANALYSIS RESULTS */}
      {activeSection === 'analysis-results' && (
        <div className={styles.collapsibleCard}>
          <div
            className={styles.collapsibleHeader}
            onClick={() => setFilterOpen(o => !o)}
          >
            <div className={styles.collapsibleTitle}>
              <FilterList />
              <Typography variant="subtitle1" className={styles.collapsibleTitle}>
                Filter by Hazards
              </Typography>
            </div>
            {filterOpen ? <ExpandLess /> : <ExpandMore />}
          </div>

          {filterOpen && (
            <div className={styles.filterContent}>
              <div className={styles.selectAllRow}>
                <input
                  type="checkbox"
                  checked={allSelected}
                  onChange={toggleSelectAll}
                />
                Select All Hazards
              </div>

              {HAZARDS.map(h => (
                <div key={h.name} className={styles.hazardRow}>
                  <input
                    type="checkbox"
                    checked={selectedHazards.includes(h.name)}
                    onChange={() => toggleHazard(h.name)}
                  />
                  {h.icon}
                  <Typography variant="subtitle1">{h.name}</Typography>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* TABS */}
      <div className={styles.navigationContainer}>
        {policy.sections.map(s => (
          <button
            key={s.key}
            className={`${styles.navButton} ${activeSection === s.key ? styles.active : ''
              }`}
            onClick={() => handleTabClick(s.key)}
          >
            <Typography variant="body1">
              {s.title}
            </Typography>
          </button>
        ))}
      </div>

      {/* CONTENT */}
      {currentSection && (
        <div className={styles.card}>
          <Typography
            variant="h6"

            className={styles.mainSectionTitle}
          >
            {currentSection.title}
          </Typography>

          <div className={styles.cardContent}>
            {Array.isArray(currentSection.content) ? (
              renderAnalysisResults(currentSection.content)
            ) : (
              <>
                {currentSection.content?.text && (
                  <Typography
                    variant="body1"

                  >
                    {currentSection.content.text}
                  </Typography>
                )}

                {currentSection.content?.objectives?.length > 0 && (
                  <div className={styles.objectivesContainer}>
                    {currentSection.content.objectives.map((obj, idx) => (
                      <div key={idx} className={styles.labCard}>

                        <div
                          className={styles.labHeader}
                          onClick={() => toggleObjectiveExpansion(idx)}
                        >
                          <div className={styles.labHeaderContent}>
                            <CheckCircle className={styles.locationIcon} />

                            <Typography
                              variant="h6"
                              className={styles.labTitle}
                            >
                              {obj.title}
                            </Typography>
                          </div>

                          {expandedObjectives[idx]
                            ? <ExpandLess />
                            : <ExpandMore />
                          }
                        </div>

                        {expandedObjectives[idx] && (
                          <div className={styles.labContent}>
                            <Typography
                              variant="body1"
                              className={styles.objectiveDescription}
                            >
                              {obj.description}
                            </Typography>
                          </div>
                        )}

                      </div>
                    ))}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default PolicyDetailPage;
